{
  "common": {
    "to": "hasta",
    "from": "desde"
  },
  "missing_info": {
    "clinical_history": "¿Qué es el historial clínico?\n\nEl historial recoge todas las visitas al veterinario, tanto por enfermedad o accidente, como las visitas rutinarias o vacunaciones, con la fecha de la visita y las notas veterinarias correspondientes. Cada página de este documento debe estar numerada y en la hoja final necesitamos que esté la firma y el sello de la clínica. También debe añadir una certificación de que las visitas que se recogen en el historial son las únicas veces que tu mascota ha ido a esa clínica\n\n¿Cómo consigo el historial clínico? \n\n¡Muy fácil! Tu veterinario te puede proporcionar el historial clínico, sólo tienes que pedírselo. En caso de que hayas acudido a más de una clínica, tendrás que solicitarlo en cada una de ellas. Si solo ha ido a una clínica para poner vacunas, igualmente, necesitaremos el historial y que aparezcan estas visitas.",
    "vet_report": "Informe veterinario\n\nEl informe es un documento que refleja los detalles de la visita por la que nos solicitas el reembolso. Este debe contener la siguiente información:\n    • Motivo de la visita. Por ejemplo, \"mi perro presenta dolor en la pata.\"\n    • Síntomas presentes. Por ejemplo, \"dolor al tacto, cojera, bulto en la pata...\"\n    • Fecha de aparición de los síntomas.\n    • Pruebas diagnósticas realizadas. Por ejemplo, radiografías, exploración física...\n    • Diagnóstico. Por ejemplo, \"traumatismo por contusión en pierna trasera.\"\n    • Tratamiento. Por ejemplo, \"reposo, crema antiinflamatoria, medicación...\"\n    • Fecha de revisión programada.",
    "invoice": "Factura\n\nPara que una factura sea válida debe tener la siguiente información.\n    • Fecha de expedición de la factura\n    • Número de CIF de la clínica veterinaria o farmacia\n    • Número de factura\n    • Tiene que aparecer la palabra factura, ya que no aceptamos tickets, albaranes o presupuestos.\n    • El importe desglosado según los tratamientos o medicación que ha recomendado el veterinario\n\nPuede ser que hayas enviado una factura correcta, pero que la foto sea borrosa, de baja resolución o que haya algo que nos impida ver bien los datos de la factura . Envíanos una foto de nuevo para que se pueda leer bien.",
    "health": {
      "templates": [
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "One single document",
              "value": "Envíanos la factura como un único documento, preferiblemente en formato PDF. Tal como lo has enviado, no podemos seguir el orden del contenido correctamente. Si tu veterinario te dio la factura impresa y necesitas hacerle fotos, asegúrate de que se vea completa en una sola foto.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Invoice complete",
              "value": "Necesitamos la factura completa. Por favor, descarga la factura en formato PDF y envíanos el documento en el apartado de factura. No podemos aceptar facturas en varias capturas de pantalla."
            },
            {
              "label": "Unreadable",
              "value": "La factura que nos envías no se puede leer correctamente o está cortada. Por favor, envía la factura completa en formato PDF.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Duplicated same invoice",
              "value": "Número de factura repetido: Ya nos has enviado una factura con el mismo número previamente. \n\n<b>Cada factura debe tener un número único;</b> no puede haber dos facturas del mismo emisor y año con el mismo número.\n\nAcude a tu clínica para que emitan una nueva factura válida\n\nEnvíanos la factura nueva, asegurándote de que esté firmada y sellada por la clínica.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Duplicated other invoice",
              "value": "Número de factura repetido: Ya hemos recibido una factura con el mismo número perteneciente a otra mascota. \n\n<b>Cada factura debe tener un número único;</b> no puede haber dos facturas del mismo emisor y año con el mismo número.\n\nAcude a tu clínica para que emitan una nueva factura válida\n\nEnvíanos la factura nueva, asegurándote de que esté firmada y sellada por la clínica.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "The receipt covers the invoice",
              "value": "El ticket tapa la factura y no podemos leer su contenido.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Duplicated invoice",
              "value": "Hemos recibido una factura de esta clínica con el mismo número de factura pero de otra mascota, con lo que no es válida. Las facturas deben tener un número único de factura, no pueden existir dos facturas del mismo emisor y año con el mismo número de factura. Acude a tu clínica y pide que te emitan una factura válida.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "More than one pet",
              "value": "La factura que envías incluye gastos de varias mascotas. Por favor, mándanos una factura separada para cada mascota asegurada.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Missing invoice",
              "value": "Necesitamos que nos envíes la factura de los servicios realizados. Recuerda que debe aparecer el <b>número CIF/NIF</b> de la clínica, el <b>número de la factura</b> y la <b>fecha</b> en la que se hizo el gasto.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Wrong pet",
              "value": "La factura que nos envías no corresponde a la mascota asegurada.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Invoice not paid",
              "value": "La factura no está pagada o solo has pagado parte de ella. Únicamente aceptamos facturas abonadas en su totalidad.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Not an invoice",
              "value": "El documento que nos envías no es una factura. No te preocupes, para conseguirla debes volver al veterinario, o farmacia, y pedirle que te haga una factura. Debe aparecer el <b>número CIF/NIF</b> de la clínica, el <b>número de la factura</b> y la <b>fecha</b> en la que se hizo el gasto. Según las condiciones de la póliza, solo podemos aceptar facturas. Ten en cuenta que <b>presupuestos, facturas proforma, facturas simplificadas o facturas número 0</b> no son válidas.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Invoice number",
              "value": "En la factura que nos envías falta el número de factura.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "CIF",
              "value": "El documento que has adjuntado no es una factura, por favor pídele a tu veterinario que emita una factura añadiendo el número CIF de la clínica.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Upfront payment",
              "value": "La factura que nos has enviado muestra que ya realizaste un pago parcial anteriormente. Para poder tramitar el reembolso, necesitamos que nos envíes también la factura de ese primer pago que hiciste.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Hemos recibido tu solicitud de reembolso, pero no podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF y adjúntalos a través de la app."
            },
            {
              "label": "Signed and stamped",
              "value": "Necesitamos que nos envíes la factura firmada y sellada por tu veterinario.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            }
          ]
        },
        {
          "group": "CLINICAL_HISTORY",
          "options": [
            {
              "label": "Missing",
              "value": "Necesitamos que nos envíes el historial veterinario de tu mascota desde que vive contigo. Solicítalo en todas las clínicas donde ha sido atendida. Debe incluir:\n - <b>Todas las visitas al veterinario:</b> Ya sea para vacunas, revisiones rutinarias, enfermedades o accidentes.\n - <b>La fecha de cada visita</b> y las notas que escribió el veterinario.\n - <b>Una confirmación de que está completo:</b> El veterinario debe escribir algo como: 'No hay más visitas registradas en esta clínica'.\n - <b>Firmado y sellado por la clínica.</b>\n - <b>Un historial por cada clínica:</b> Si has visitado más de una clínica, necesitamos un historial por cada una, incluso si solo fue para vacunar a tu mascota.\n - <b>No aceptamos hojas sueltas ni documentos incompletos.</b>"
            },
            {
              "label": "Loose sheets",
              "value": "Necesitamos que nos envíes el historial clínico en un único documento. Lamentablemente, no aceptamos hojas sueltas o que estén desordenadas."
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "¿What's missing?",
                "options": [
                  {
                    "label": "Condition",
                    "value": "En el historial falta la visita relacionada con la condición {{condicion;STRING;true}} mencionada en el informe veterinario."
                  },
                  {
                    "label": "Clinic data",
                    "value": "En el historial faltan alguno o todos los datos de la clínica. Debe aparecer el nombre de la clínica, su CIF y/o dirección."
                  },
                  {
                    "label": "Pet details",
                    "value": "En el historial falta alguno o todos los datos de la mascota: nombre, raza y/o chip."
                  },
                  {
                    "label": "Visit dates",
                    "value": "En el historial faltan las siguientes fechas: {{fechas;DATE_RANGE;true}}"
                  },
                  {
                    "label": "Clinical notes",
                    "value": "El historial no incluye todas las notas del veterinario correspondientes a cada visita."
                  },
                  {
                    "label": "One or more clinics",
                    "value": "Faltan las visitas correspondientes a una o más clínicas: {{nombre_clínica;STRING;true}}."
                  }
                ]
              }
            },
            {
              "label": "Not a clinical history",
              "value": "El documento que nos envías no es un historial. Solicítalo en todas las clínicas donde ha sido atendida. Debe incluir:\n - <b>Todas las visitas al veterinario:</b> Ya sea para vacunas, revisiones rutinarias, enfermedades o accidentes.\n - <b>La fecha de cada visita</b> y las notas que escribió el veterinario.\n - <b>Una confirmación de que está completo:</b> El veterinario debe escribir algo como: 'No hay más visitas registradas en esta clínica'.\n - <b>Firmado y sellado por la clínica.</b>\n - <b>Un historial por cada clínica:</b> Si has visitado más de una clínica, necesitamos un historial por cada una, incluso si solo fue para vacunar a tu mascota.\n - <b>No aceptamos hojas sueltas ni documentos incompletos.</b>"
            },
            {
              "label": "Repeated attempts",
              "value": "Como te hemos dicho anteriormente, sin el historial de tu mascota no podemos tramitar tu solicitud. Solicítalo en todas las clínicas donde ha sido atendida. Debe incluir:\n - <b>Todas las visitas al veterinario:</b> Ya sea para vacunas, revisiones rutinarias, enfermedades o accidentes.\n - <b>La fecha de cada visita</b> y las notas que escribió el veterinario.\n - <b>Una confirmación de que está completo:</b> El veterinario debe escribir algo como: 'No hay más visitas registradas en esta clínica'.\n - <b>Firmado y sellado por la clínica.</b>\n - <b>Un historial por cada clínica:</b> Si has visitado más de una clínica, necesitamos un historial por cada una, incluso si solo fue para vacunar a tu mascota.\n - <b>No aceptamos hojas sueltas ni documentos incompletos.</b>"
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Costline Explanation",
              "value": {
                "group": "Explanation",
                "options": [
                  {
                    "label": "All",
                    "value": "Pide a tu veterinario que incluya en un informe o anexo a la factura a qué tratamiento corresponde cada concepto de la factura, ya que hay conceptos que no vienen especificados. Debe incluir el nombre del tratamiento y su precio.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "One or more costlines",
                    "value": "Pide a tu veterinario que incluya en un informe o anexo a la factura a qué tratamiento corresponde estos conceptos de la factura: {{línea_de_coste;STRING;true}}. Debe incluir el nombre del tratamiento y su precio.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  }
                ]
              }
            },
            {
              "label": "Sessions",
              "value": "Necesitamos un informe con todas las sesiones realizadas y sus fechas. Envíanos este informe al finalizar el tratamiento, ya que no podemos reembolsar sesiones pendientes.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Changes",
              "value": "El informe veterinario es un documento oficial, por lo que no podemos aceptar cambios en él. Necesitamos que tu veterinario nos envíe un nuevo informe sellado, con su nombre completo, número de colegiado y firma, justificando el cambio realizado.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "One document",
              "value": "Envíanos el informe como un único documento, preferiblemente en formato PDF. Tal como lo has enviado, no podemos seguir el orden del contenido correctamente. Si tu veterinario te dio el informe impreso y necesitas hacerle fotos, asegúrate de enviar cada página en una foto separada, que se vea completa y en el orden correcto.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Missing vet report",
              "value": {
                "group": "¿What's missing?",
                "options": [
                  {
                    "label": "Clinic",
                    "value": "Falta el informe veterinario de las siguientes clínicas: {{clinica;STRING;true}}.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Complete Vet report",
                    "value": "Necesitamos el informe veterinario. Este debe ser un documento redactado por el veterinario que detalle la visita por la cual solicitas el reembolso. El informe debe incluir lo siguiente: \n\n<b>Motivo de la visita:</b> Ej: 'Mi perro tiene dolor en la pata.'\n\n<b>Síntomas observados:</b> Ej: 'Dolor al tacto, cojera, bulto en la pata.'\n\n<b>Fecha de inicio de los síntomas.</b>\n\n<b>Pruebas realizadas:</b> Ej: 'Radiografías, exploración física.'\n\n<b>Diagnóstico:</b> Ej: 'Traumatismo por contusión en la pierna trasera.'\n\n<b>Tratamiento indicado:</b> Ej: 'Reposo, medicación.'\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Date",
                    "value": "Falta el informe veterinario de las siguientes fechas: {{fecha;DATE_RANGE;true}}.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  }
                ]
              }
            },
            {
              "label": "Date of symptoms",
              "value": {
                "group": "¿Quién debe proporcionar la fecha de aparición de los síntomas?",
                "options": [
                  {
                    "label": "Petparent",
                    "value": "Necesitamos que nos indiques la fecha de aparición de los síntomas.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF.",
                    "type": "DATE"
                  },
                  {
                    "label": "Vet",
                    "value": "En el informe que nos envías no aparece la fecha en la que aparecieron los síntomas. Por favor, pídele a tu veterinario que la añada.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  }
                ]
              }
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "¿What's missing?",
                "options": [
                  {
                    "label": "Costline explanation",
                    "value": "El informe veterinario no menciona algunos de los conceptos que aparecen en la factura. Por ejemplo, si la factura incluye medicación pero el informe no lo indica, necesitamos que el veterinario lo actualice incluyendo todos los tratamientos realizados.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Clinic data",
                    "value": "En el informe falta alguno o todos los datos de la clínica: nombre, CIF y dirección.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Pet details",
                    "value": "En el informe falta alguno o todos los datos de la mascota: nombre, raza y/o chip.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Diagnosis",
                    "value": "En el informe falta el diagnóstico de tu mascota.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Date of visit",
                    "value": "En el informe falta la fecha de la visita al veterinario.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Pages",
                    "value": "Al informe que nos envías le faltan páginas, está incompleto.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Diagnostics tests",
                    "value": "En el informe faltan las pruebas diagnósticas (como radiografías, análisis, etc) realizadas a tu mascota.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Symptoms/reason for visit",
                    "value": "En el informe falta incluir el motivo por el cual acudiste a la consulta veterinaria, es decir, una descripción clara de los síntomas que presenta tu mascota.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Treatment",
                    "value": "En el informe falta el tratamiento preescrito a tu mascota.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  }
                ]
              }
            },
            {
              "label": "Inconsistency between documents",
              "value": "Hemos detectado las siguientes incongruencias en los documentos que nos envías: {{inconsistency;STRING;true}}. Necesitamos una aclaración por parte de tu veterinario en un informe.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Previous related reports",
              "value": "Necesitamos los informes de las visitas anteriores relacionadas con esta condición. En ellos debe indicarse los síntomas, la fecha en que comenzaron, las pruebas realizadas, los tratamientos indicados y cómo ha sido la evolución. Si te resulta más fácil, puedes enviarnos el historial clínico completo.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Previous visits",
              "value": "Necesitamos que nos envíes los informes previos relacionados con la visita.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Referral report",
              "value": "Para poder procesar su solicitud, necesitamos el informe de su veterinario habitual donde se le remite al especialista\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Costline breakdown",
              "value": "Pide a tu veterinario que indique en un informe o anexo a la factura cada servicio o tratamiento realizado a la mascota y su precio de manera individual.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Vet report doesn't match the invoice",
              "value": "El informe que nos envías no coincide con la factura. Por favor, asegúrate de que el informe tenga la misma fecha que la factura y que incluya los conceptos que se están cobrando en ella.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Unreadable",
              "value": "El informe veterinario que nos envías no se puede leer correctamente o está cortado. Por favor, envía el informe completo en formato PDF.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Not a vet report",
              "value": "El documento que nos has enviado no es un informe veterinario. Este debe ser un documento redactado por el veterinario que detalle la visita por la cual solicitas el reembolso. El informe debe incluir lo siguiente:\n - <b>Motivo de la visita:</b> Ej: 'Mi perro tiene dolor en la pata.'\n - <b>Síntomas observados:</b> Ej: 'Dolor al tacto, cojera, bulto en la pata.'\n - <b>Fecha de inicio de los síntomas.</b>\n - <b>Pruebas realizadas:</b> Ej: 'Radiografías, exploración física.'\n - <b>Diagnóstico:</b> Ej: 'Traumatismo por contusión en la pierna trasera.'\n - <b>Tratamiento indicado:</b> Ej: 'Reposo, medicación.'.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Chronic condition",
              "value": "Para reembolsos de medicación crónica, necesitamos un informe de seguimiento de tu veterinario que explique cómo está tu mascota y cómo evoluciona su tratamiento. Este informe debe actualizarse cada 6 meses.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Treatment recommendation",
              "value": "En el documento que nos envías podemos ver los tratamientos que ha recomendado el veterinario, pero necesitamos un informe completo de la visita.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Signed and stamped",
              "value": "Necesitamos que nos envíes el informe firmado y sellado por tu veterinario.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
                          {
                                          "label": "Screenshots Not Accepted",
                                                          "value": "Hemos recibido tu solicitud de reembolso, pero no podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF y adjúntalos a través de la app."
                                                                        }
          ]
        },
        {
          "group": "ADMINISTRATIVE_DOCUMENTATION",
          "options": [
            {
              "label": "Certificado de alta del chip",
              "value": "Necesitamos que nos envíes el certificado de alta del chip de tu mascota."
            },
            {
              "label": "Contrato de compra o adopción",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Falta",
                    "value": "Necesitamos que nos envíes el contrato de compra o adopción de tu mascota."
                  },
                  {
                    "label": "No es legible",
                    "value": "Contrato de compra o adopción: El documento que nos envías no se puede leer correctamente."
                  }
                ]
              }
            },
            {
              "label": "IBAN",
              "value": "Necesitamos tu número de IBAN",
              "type": "IBAN"
            }
          ]
        },
        {
          "group": "MEDICAL_IMAGING",
          "options": [
            {
              "label": "Ultrasound",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Ecografía: Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento."
                  },
                  {
                    "label": "Missing",
                    "value": "Necesitamos el informe original de la ecografía realizada. El informe ha de incluir los datos de la mascota y la fecha de realización de la prueba."
                  },
                  {
                    "label": "Unreadable",
                    "value": "La ecografía que nos envías no se puede leer correctamente."
                  }
                ]
              }
            },
            {
              "label": "Echocardiography",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Ecocardiografía: Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento."
                  },
                  {
                    "label": "Missing",
                    "value": "Necesitamos el informe original de la ecocardiografía realizada. El informe ha de incluir los datos de la mascota y la fecha de realización de la prueba."
                  },
                  {
                    "label": "Unreadable",
                    "value": "La ecocardiografía que nos envías no se puede leer correctamente."
                  }
                ]
              }
            },
            {
              "label": "Radiography",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Radiografía: Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento."
                  },
                  {
                    "label": "Missing",
                    "value": "Necesitamos que nos adjuntes las radiografías realizadas con marca de agua original o formato DICOM (.dcm)."
                  },
                  {
                    "label": "Original documents",
                    "value": "Necesitamos las imágenes originales de la radiografía realizada. Estas pueden estar formato DICOM (.dcm). Este formato es como el jpg de las fotografías. Aunque tú no puedas abrirlas, nosotros sí."
                  },
                  {
                    "label": "Unreadable",
                    "value": "La radiografía que nos envías no se puede leer correctamente."
                  }
                ]
              }
            },
            {
              "label": "MRI",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Resonancia: Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento."
                  },
                  {
                    "label": "Missing",
                    "value": "Necesitamos el informe original de la resonancia realizada. El informe ha de incluir los datos de la mascota y la fecha de realización de la prueba."
                  },
                  {
                    "label": "Unreadable",
                    "value": "La resonancia que nos envías no se puede leer correctamente."
                  }
                ]
              }
            },
            {
              "label": "TAC",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "TAC: Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento."
                  },
                  {
                    "label": "Missing",
                    "value": "Necesitamos el informe original del TAC realizado. El informe ha de incluir los datos de la mascota y la fecha de realización de la prueba."
                  },
                  {
                    "label": "Unreadable",
                    "value": "El TAC que nos envías no se puede leer correctamente."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "MEDICAL_ANALYTIC",
          "options": [
            {
              "label": "Analytics",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Analítica: Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Necesitamos los resultados o el documento original de la analítica realizada. El informe ha de incluir los datos de la mascota y la fecha de realización de la prueba.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Los resultados de la analítica que nos envías no se pueden leer correctamente.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  }
                ]
              }
            },
            {
              "label": "Biopsy",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Biopsia: Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Necesitamos los resultados o el documento original de la biopsia realizada. El informe ha de incluir los datos de la mascota y la fecha de realización de la prueba.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Los resultados de la biopsia que nos envías no se pueden leer correctamente.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  }
                ]
              }
            },
            {
              "label": "Citology",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Citología: Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Necesitamos los resultados o el documento original de la citología realizada. El informe ha de incluir los datos de la mascota y la fecha de realización de la prueba.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Los resultados de la citología que nos envías no se pueden leer correctamente.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  }
                ]
              }
            },
            {
              "label": "Urine test",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Análisis de orina: Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Necesitamos los resultados o el documento original del análisis de orina realizado. El informe ha de incluir los datos de la mascota y la fecha de realización de la prueba.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Los resultados del análisis de orina que nos envías no se pueden leer correctamente.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Vaccination card",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento. En el apartado de notas te indicaremos dónde hemos visto un cambio no justificado."
                  },
                  {
                    "label": "Missing",
                    "value": "Necesitamos que nos envíes una foto de la cartilla o pasaporte donde aparezcan los datos de la mascota y todas las vacunas que ha recibido."
                  },
                  {
                    "label": "Unreadable",
                    "value": "El documento que nos envías no se puede leer correctamente."
                  },
                  {
                    "label": "Chipnumber",
                    "value": "Necesitamos que nos envíes una foto de la cartilla o pasaporte donde aparezca el número de chip de la mascota."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    "prevention": {
      "templates": [
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Changes",
              "value": "Cartilla de vacunación: Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento."
            },
            {
              "label": "Missing",
              "value": "Necesitamos que nos envíes una foto de la cartilla o pasaporte donde aparezca esta vacuna y todas las vacunas aplicadas."
            },
            {
              "label": "Unreadable",
              "value": "La cartilla de vacunación que nos envías no se puede leer correctamente."
            },
            {
              "label": "Chipnumber",
              "value": "Necesitamos que nos envíes una foto de la cartilla o pasaporte donde aparezca el número de chip de la mascota."
            }
          ]
        },
        {
          "group": "CLINICAL_HISTORY",
          "options": [
            {
              "label": "Missing",
              "value": "Necesitamos que nos envíes el historial veterinario de tu mascota desde que vive contigo. Solicítalo en todas las clínicas donde ha sido atendida. Debe incluir:\n - <b>Todas las visitas al veterinario:</b> Ya sea para vacunas, revisiones rutinarias, enfermedades o accidentes.\n - <b>La fecha de cada visita</b> y las notas que escribió el veterinario.\n - <b>Una confirmación de que está completo:</b> El veterinario debe escribir algo como: 'No hay más visitas registradas en esta clínica'.\n - <b>Firmado y sellado por la clínica.</b>\n - <b>Un historial por cada clínica:</b> Si has visitado más de una clínica, necesitamos un historial por cada una, incluso si solo fue para vacunar a tu mascota.\n - <b>No aceptamos hojas sueltas ni documentos incompletos.</b>"
            }
          ]
        },
        {
          "group": "MEDICAL_IMAGING",
          "options": [
            {
              "label": "Missing",
              "value": "Necesitamos el informe original de la prueba realizada. El informe ha de incluir los datos de la mascota y la fecha de realización de la prueba"
            }
          ]
        },
        {
          "group": "MEDICAL_ANALYTIC",
          "options": [
            {
              "label": "Missing",
              "value": "Necesitamos el informe original de la analítica realizada. El informe ha de incluir los datos de la mascota y la fecha de realización de la prueba\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            }
          ]
        },
        {
          "group": "ADMINISTRATIVE_DOCUMENTATION",
          "options": [
            {
              "label": "Chip registration certificate",
              "value": "Necesitamos que nos envíes el certificado de alta del chip de tu mascota."
            },
            {
              "label": "Purchase or adoption contract",
              "value": {
                "group": "¿Qué sucede?",
                "options": [
                  {
                    "label": "Missing",
                    "value": "Necesitamos que nos envíes el contrato de compra o adopción de tu mascota."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Contrato de compra o adopción: El documento que nos envías no se puede leer correctamente."
                  }
                ]
              }
            },
            {
              "label": "IBAN",
              "value": "Necesitamos tu número de IBAN",
              "type": "IBAN"
            }
          ]
        },
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "Changes",
              "value": "Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Complete invoice",
              "value": "Necesitamos la factura completa. Por favor, descarga la factura en formato PDF y envíanos el documento en el apartado de factura. No podemos aceptar facturas en varias capturas de pantalla."
            },
            {
              "label": "CIF",
              "value": "En la factura que nos envías falta el CIF o está incompleto.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Invoice number",
              "value": "En la factura que nos envías falta el número de factura o está incompleto.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Receipt covers the invoice",
              "value": "El ticket tapa la factura o parte de ella y no podemos leer su contenido\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Duplicated invoice",
              "value": "Hemos recibido una factura de esta clínica con el mismo número de factura pero de otra mascota, con lo que no es válida. Las facturas deben tener un número único de factura, no pueden existir dos facturas del mismo emisor y año con el mismo número de factura. Acude a tu clínica y pide que te emitan una factura válida.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "More than one pet",
              "value": "La factura que nos envías tiene costes asociados a varias mascotas. Por favor, envíanos una factura individual por cada mascota asegurada.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Missing",
              "value": "Necesitamos que nos envíes la factura de los servicios realizados. Recuerda que debe aparecer el <b>número CIF/NIF</b> de la clínica, el <b>número de la factura</b> y la <b>fecha</b> en la que se hizo el gasto.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Unreadable",
              "value": "La factura que nos envías no se puede leer correctamente o está cortada. Por favor, envía la factura completa en formato PDF.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Not an invoice",
              "value": "El documento que nos envías no es una factura. No te preocupes, para conseguirla debes volver al veterinario, o farmacia, y pedirle que te haga una factura. Debe aparecer el <b>número CIF/NIF</b> de la clínica, el <b>número de la factura</b> y la <b>fecha</b> en la que se hizo el gasto. Según las condiciones de la póliza, solo podemos aceptar facturas. Ten en cuenta que <b>presupuestos, facturas proforma, facturas simplificadas o facturas número 0</b> no son válidas.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "One single document",
              "value": "Envíanos la factura como un único documento, preferiblemente en formato PDF. Tal como lo has enviado, no podemos seguir el orden del contenido correctamente. Si tu veterinario te dio la factura impresa y necesitas hacerle fotos, asegúrate de que se vea completa en una sola foto.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Hemos recibido tu solicitud de reembolso, pero no podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF y adjúntalos a través de la app."
            },
            {
              "label": "Signed and stamped",
              "value": "Necesitamos que nos envíes la factura firmada y sellada por tu veterinario.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Costline explanation",
              "value": "Pide a tu veterinario que incluya en un informe o anexo a la factura a qué tratamiento corresponden estos conceptos de la factura: {{línea_de_coste;STRING;true}}. Debe incluir el nombre del tratamiento y su precio.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Changes",
              "value": "Necesitamos que tu veterinario redacte un informe sellado, con su nombre completo, número de colegiado y firmado explicando por qué se ha producido un cambio en el documento.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "¿What's missing?",
                "options": [
                  {
                    "label": "Clinic",
                    "value": "Falta el informe veterinario de las siguientes clínicas: {{clinica;STRING;true}}.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "All",
                    "value": "Necesitamos el informe veterinario. Este debe ser un documento redactado por el veterinario que detalle la visita por la cual solicitas el reembolso. El informe debe incluir lo siguiente: \n\n<b>Motivo de la visita:</b> Ej: 'Mi perro tiene dolor en la pata.'\n\n<b>Síntomas observados:</b> Ej: 'Dolor al tacto, cojera, bulto en la pata.'\n\n<b>Fecha de inicio de los síntomas.</b>\n\n<b>Pruebas realizadas:</b> Ej: 'Radiografías, exploración física.'\n\n<b>Diagnóstico:</b> Ej: 'Traumatismo por contusión en la pierna trasera.'\n\n<b>Tratamiento indicado:</b> Ej: 'Reposo, medicación.'\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  },
                  {
                    "label": "Dates",
                    "value": "Falta el informe veterinario de las siguientes fechas: {{fecha;DATE_RANGE;true}}.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
                  }
                ]
              }
            },
            {
              "label": "Not a vet report",
              "value": "El documento que nos has enviado no es un informe veterinario. Este debe ser un documento redactado por el veterinario que detalle la visita por la cual solicitas el reembolso. El informe debe incluir lo siguiente:\n - <b>Motivo de la visita:</b> Ej: 'Mi perro tiene dolor en la pata.'\n - <b>Síntomas observados:</b> Ej: 'Dolor al tacto, cojera, bulto en la pata.'\n - <b>Fecha de inicio de los síntomas.</b>\n - <b>Pruebas realizadas:</b> Ej: 'Radiografías, exploración física.'\n - <b>Diagnóstico:</b> Ej: 'Traumatismo por contusión en la pierna trasera.'\n - <b>Tratamiento indicado:</b> Ej: 'Reposo, medicación.'.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Missing",
              "value": "Necesitamos el informe veterinario. Este debe ser un documento redactado por el veterinario que detalle la visita por la cual solicitas el reembolso. El informe debe incluir lo siguiente: \n\n<b>Motivo de la visita:</b> Ej: 'Mi perro tiene dolor en la pata.'\n\n<b>Síntomas observados:</b> Ej: 'Dolor al tacto, cojera, bulto en la pata.'\n\n<b>Fecha de inicio de los síntomas.</b>\n\n<b>Pruebas realizadas:</b> Ej: 'Radiografías, exploración física.'\n\n<b>Diagnóstico:</b> Ej: 'Traumatismo por contusión en la pierna trasera.'\n\n<b>Tratamiento indicado:</b> Ej: 'Reposo, medicación.'\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Costline breakdown",
              "value": "Pide a tu veterinario que indique en un informe o anexo a la factura cada servicio o tratamiento realizado a la mascota y su precio de manera individual.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Vet report doesn't match the invoice",
              "value": "El informe que nos envías no se corresponde con la factura. Las facturas siempre deben estar relacionadas con los informes.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Unreadable",
              "value": "El informe veterinario que nos envías no se puede leer correctamente o está cortado. Por favor, envía el informe completo en formato PDF.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
            {
              "label": "Signed and stamped",
              "value": "Necesitamos que nos envíes el informe firmado y sellado por tu veterinario.\n\nNo podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF."
            },
                          {
                                          "label": "Screenshots Not Accepted",
                                                          "value": "Hemos recibido tu solicitud de reembolso, pero no podemos aceptar capturas de pantalla ni fotos de pantallas de los documentos. Por favor, solicita a tu clínica los documentos en PDF y adjúntalos a través de la app."
                                                                        }
          ]
        }
      ]
    }
  },
  "resolution": {
    "templates": [
      {
        "group": "Waiting period",
        "options": [
          {
            "label": "5 DAYS WAITING PERIOD / PREEXISTENCE",
          "value": "Tras revisar la documentación de {{petName}}, te informamos de que tu factura, o parte de ella, no ha podido ser aprobada. Tu póliza tiene un tiempo de espera de 5 días para los accidentes desde la fecha de contratación. Este periodo se denomina carencia. En este caso, la condición indicada: {{condition;STRING;true}}, apareció o recibió atención veterinaria el: {{date;DATE;true}}, dentro de esos 5 días. Por ello, no queda cubierta por el seguro y se considera preexistente. Si esta condición se prolonga en el tiempo o vuelve a manifestarse en el futuro de forma recurrente o crónica, ni este episodio ni las posibles recaídas o complicaciones derivadas podrán ser reembolsados, independientemente de la fecha del diagnóstico definitivo."
        },
        
                  {
            "label": "28 DAYS WAITING PERIOD / PREEXISTENCE",
                      "value": "Tras revisar la documentación de {{petName}}, te informamos de que tu factura, o parte de ella, no ha podido ser aprobada. Tu póliza tiene un tiempo de espera de 28 días para enfermedades desde la fecha de contratación. Este periodo se denomina carencia. La póliza define una lista específica de situaciones con carencia reducida de 5 días, y esta condición lamentablemente no se incluye entre ellas, por lo que aplica la carencia general de 28 días. En este caso, la condición indicada: {{condition;STRING;true}}, apareció o recibió atención veterinaria el: {{date;DATE;true}}, dentro de esos 28 días y se clasifica como enfermedad ya que no cumple las condiciones establecidas por la póliza para ser considerada un accidente. Por ello, no queda cubierta por el seguro y se considera preexistente. Si esta condición se prolonga en el tiempo o vuelve a manifestarse en el futuro de forma recurrente o crónica, ni este episodio ni las posibles recaídas o complicaciones derivadas podrán ser reembolsados, independientemente de la fecha del diagnóstico definitivo."
          },
          {
            "label": "6 MONTH WAITING PERIOD / PREEXISTENCE",
                      "value": "Tras revisar la documentación de {{petName}}, te informamos de que tu factura, o parte de ella, no ha podido ser aprobada. Tu póliza tiene un tiempo de espera de 6 meses para determinadas enfermedades desde la fecha de contratación. Este periodo se denomina carencia. Entre estas enfermedades se incluyen: displasia de cadera, displasia de codo, rotura o enfermedad del ligamento cruzado, luxación rotuliana, atopia, dermatitis alérgica, epilepsia, trastornos de conducta, leishmania, cataratas y hernia discal. Si la mascota tenía más de 6 meses de edad cuando se contrató el seguro, estas enfermedades están sujetas a ese plazo de 6 meses, aunque su origen pueda estar relacionado con un hecho inesperado. En este caso, la condición indicada: {{condition;STRING;true}}, apareció o fue atendida el: {{date;DATE;true}}, dentro de ese periodo de 6 meses. Por ello, no queda cubierta por el seguro y se considera preexistente. Esta condición quedará fuera de cobertura también en el futuro: como los primeros síntomas o la primera visita veterinaria relacionada ocurrieron dentro del tiempo de espera de la póliza, no podemos aprobar solicitudes de reembolso futuras relacionadas con esta condición ni con cualquier síntoma, lesión o enfermedad derivada de ella. Esta condición será considerada preexistente de forma permanente aunque el diagnóstico definitivo se confirme más adelante."
          }
        ]
      },
      {
        "group": "Preexistence",
        "options": [
          {
            "label": "Preexistence/before contract",
                      "value": "Tras revisar la documentación de {{petName}}, te informamos de que tu factura, o parte de ella, no ha podido ser aprobada.\n\nLa condición que presenta tu mascota: {{condition;STRING;true}}, se considera preexistente, ya que apareció, mostró síntomas o fue atendida por primera vez el: {{date;DATE;true}}, antes del inicio de la cobertura.\n\nUna condición preexistente es cualquier lesión o enfermedad que: se haya producido o haya mostrado síntomas clínicos antes del inicio de la cobertura de la póliza, o tenga el mismo diagnóstico o los mismos síntomas que una lesión o enfermedad que la mascota hubiera padecido antes del inicio de la cobertura, o esté causada por, relacionada con o derive de una lesión, enfermedad o síntoma clínico previo al inicio de la cobertura.\n\nAdemás, esta condición quedará fuera de cobertura también en el futuro. Esto significa que no podemos aprobar solicitudes de reembolso futuras relacionadas con esta condición ni con cualquier síntoma, lesión o enfermedad derivada de ella, aunque el diagnóstico definitivo se confirme más adelante."
          },
          {
            "label": "Same diagnosis in different body part",
            "value": "Ten en cuenta que, según las condiciones de tu póliza, si tu mascota ya había padecido antes del inicio de la cobertura, o durante el periodo de carencia: (hernia o protusión discal, rotura o enfermedad del ligamento cruzado, luxación de rótula, displasia de codo o de cadera, cataratas u osteoartritis), no se reembolsarán gastos relacionados con esa misma patología, aunque más adelante se manifieste en otra parte del cuerpo. \n\nPor ejemplo, esto incluye: una hernia o protusión discal en un disco intervertebral distinto, una rotura o enfermedad del ligamento cruzado en una pata diferente."
          },
          {
            "label": "Date outside coverage period",
            "value": "Factura previa a la contratación de la póliza: Lamentablemente, tu solicitud de reembolso ha sido denegada porque la fecha de la factura que nos envías es anterior a la fecha de inicio de la póliza."
          },
          {
            "label": "Not an accident denial",
            "value": "Hemos revisado tu solicitud y, de acuerdo con las Condiciones Generales de tu póliza, este proceso no puede considerarse un Accidente a efectos de la cobertura.\n\nLa póliza establece que, para que un caso sea considerado un Accidente, debe cumplir la definición de accidente prevista en el contrato y, además, encontrarse dentro del listado de accidentes cubiertos, que incluye exclusivamente:\n\nFracturas o luxaciones articulares por traumatismo.\nLaceraciones cutáneas, heridas por mordedura (excepto picaduras de insectos) o abrasiones cutáneas.\nQuemaduras o lesiones por electrocución.\nTraumatismos por vehículo.\nIntoxicaciones.\nHeridas por arma de fuego o proyectil.\nContusiones graves o lesiones por aplastamiento.\nLesiones dentales por traumatismo.\nCuerpos extraños gastrointestinales.\n\nAdemás, las Condiciones Generales indican expresamente que las lesiones o condiciones que, aun mediando un suceso traumático, correspondan a una patología con un período de carencia específico previsto en el contrato, estarán sujetas a dicho período de carencia y no al de Accidente.\n\nPor este motivo, a este proceso le resulta de aplicación el período de carencia de 28 días, y no el período de carencia de 5 días para accidentes.\n\nDado que los síntomas y/o el tratamiento tuvieron lugar durante dicho período de carencia, lamentablemente no podemos reembolsar los gastos correspondientes."
          }
        ]
      },
      {
        "group": "Vaccinations are not up to date",
        "options": [
          {
            "label": "Vaccinations are not up to date",
            "value": "La vacunación anual no está actualizada. Según las condiciones generales de tu póliza, tu mascota tiene que estar al día de la vacunación contra las siguientes enfermedades: rabia, moquillo, hepatitis y parvovirosis. En este caso, la pauta de vacunación no está completa o no se han seguido las indicaciones de su veterinario. No se pueden cubrir los gastos veterinarios derivados del desarrollo de esta enfermedad. "
          }
        ]
      },
      {
        "group": "Disclaimer",
        "options": [
          {
            "label": "Disclaimer Clinical history",
            "value": "Historial clínico. Me gustaría recordarte que en  tu siguiente solicitud de reembolso necesitamos que nos envíes el historial clínico de tu mascota.  El historial recoge, en un único documento, todas las visitas al veterinario, tanto por enfermedad o accidente, como las visitas rutinarias o vacunaciones, con la fecha de la visita y las notas veterinarias correspondientes. En el caso de que haya ido a más de una clínica deberás solicitarlo a todas ellas. Cada página de este documento debe estar numerada y en la hoja final necesitamos que esté la firma y el sello de la clínica. También debes añadir una certificación de que las visitas que se recogen en el historial son las únicas veces que tu mascota ha ido a esa clínica."
          },
          {
            "label": "More than one pet",
            "value": "Para acelerar la tramitación de futuras solicitudes, recomendamos que cada factura se corresponda a un solo animal. Las facturas que incluyan los gastos de más de un animal pueden dar lugar a que solicitemos información adicional."
          },
          {
            "label": "Complementary sessions limit reacheds",
            "value": "Te informamos de que ya has consumido las 8 sesiones/tratamientos complementarios incluidos dentro del periodo vigente de tu contrato."
          },
          {
            "label": "Annual visit limit reached",
            "value": "Ya has utilizado la revisión anual cubierta por tu póliza."
          },
          {
            "label": "Unjustified costlines",
            "value": "Algunos de los costes indicados no están suficientemente justificados en la documentación aportada y, por lo tanto, no pueden ser evaluados conforme a las condiciones del seguro."
          },
          {
            "label": "Outside EU, UK and Andorra",
            "value": "Tu póliza no cubre gastos originados fuera de la Unión Europea, Reino Unido y Andorra."
          },
          {
            "label": "Disclaimer chronic condition revision",
            "value": "Informe revisión. Te recordamos que para poder reembolsar medicamentos crónicos es necesario realizar una revisión cada 6 meses. Necesitamos que nos envíes el informe de la revisión con tu próxima solicitud."
          },
          {
            "label": "Prostheses, implants, pacemakers and transplants",
            "value": "De acuerdo con las Condiciones Generales de tu póliza, quedan excluidos los trasplantes (incluidos los cuidados pre y postoperatorios), los marcapasos, las prótesis, los implantes (excepto los implantes de osteosíntesis), así como las partes del cuerpo o las articulaciones artificiales."
          }
        ]
      },
      {
        "group": "Preventative/routinary costline",
        "options": [
          {
            "label": "Preventative/routinary costline",
            "value": "Tratamiento Preventivo. El Seguro de Barkibu sólo cubre los gastos veterinarios que se produzcan a consecuencia de una enfermedad o un accidente. Los gastos que nos envías están relacionados con tratamientos rutinarios o preventivos, por lo que no tienen cobertura."
          }
        ]
      },
      {
        "group": "Postmortem",
        "options": [
          {
            "label": "Our condolences",
            "value": "Quiero enviarte, de parte de todo el equipo de Barkibu, toda la fuerza posible en estos momentos tan duros. Lamentamos mucho lo sucedido."
          }
        ]
      },
      {
        "group": "Prevention outside of country",
        "options": [
          {
            "label": "Prevention outside of country",
            "value": "Su póliza de prevención solo tiene cobertura en España."
          }
        ]
      },
      {
        "group": "Shunt/congenital malformation",
        "options": [
          {
            "label": "Shunt/congenital malformation",
            "value": "Según las condiciones generales, no están cubiertos los gastos relacionados con anastomosis vasculares patológicas congénitas y con malformaciones cardíacas congénitas (por ejemplo, shunt portosistémico o PDA), aunque no se conocieran en el momento de contratar la póliza."
          }
        ]
      },
      {
        "group": "Brachycephalic Syndrome",
        "options": [
          {
            "label": "Brachycephalic Syndrome",
            "value": "El síndrome braquicefálico se encuentra excluido de cobertura según lo establecido en las Condiciones Generales de la póliza. En consecuencia, los gastos derivados de su diagnóstico y tratamiento no pueden ser reembolsados."
          }
        ]
      },
      {
        "group": "Annual limit reached",
        "options": [
          {
            "label": "Annual limit reached",
            "value": "Te informamos de que has llegado al límite anual de tu póliza."
          }
        ]
      },
      {
        "group": "Prevention",
        "options": [
          {
            "label": "Vaccinations not covered",
            "value": "Vacuna no cubierta: El paquete de cuidados preventivos de tu Seguro Veterinario incluye la vacuna de la rabia, la polivalente y la tos de las perreras para perros y la vacuna de la rabia, la trivalente y la leucemia para gatos."
          },
          {
            "label": "Annual visit with tests",
            "value": "Revisión anual con pruebas: El paquete de cuidados preventivos de tu Seguro Veterinario incluye una revisión preventiva anual, que no esté relacionada con una enfermedad, accidente o síntoma de la mascota. En esta revisión no están incluidas las pruebas o analíticas que le puedan hacer a tu mascota. La revisión que nos envías no cumple estos requisitos, por lo que no tiene cobertura."
          }
        ]
      }
    ]
  },
  "close_claim": {
    "templates": [
      {
        "group": "Cierre de solicitud",
        "options": [
          {
            "label": "Missing information",
            "value": "Hemos cerrado tu solicitud porque la documentación recibida no es suficiente para poder valorarla. Te indicamos a través de la app los documentos necesarios, pero no los hemos recibido correctamente. Si quieres que la revisemos de nuevo, por favor crea una nueva solicitud incluyendo toda la información requerida."
          },
          {
            "label": "Outstanding documents in another request",
            "value": "Hemos cerrado esta solicitud porque está relacionada con otra que aún sigue abierta y pendiente de documentación por tu parte. Debes subir los documentos requeridos directamente en la solicitud que aparece en la app como “Falta documentación”."
          },
          {
            "label": "Duplicated invoice",
            "value": "Hemos cerrado tu solicitud porque tras revisar nuevamente las facturas, hemos comprobado que ya fueron incluidas en una solicitud anterior."
          },
          {
            "label": "Erroneous pet",
            "value": "Hemos cerrado tu solicitud porque los gastos presentados no corresponden a la mascota asegurada en esta póliza."
          },
          {
            "label": "Suspended/cancelled policy",
            "value": "Hemos cerrado tu solicitud porque tu póliza está actualmente suspendida. Hemos intentado contactar contigo en varias ocasiones para actualizar el pago y cobrar las cuotas pendientes, pero no lo hemos conseguido. Una vez regularices la situación, podrás enviar una nueva solicitud desde la app."
          },
          {
            "label": "Pet parent asked to close the claim",
            "value": "Hemos cerrado tu solicitud porque nos has pedido que lo hiciéramos."
          },
          {
            "label": "Fraud documentation from clinic",
            "value": "Debido a las discrepancias detectadas en solicitudes de reembolso anteriores, a partir de ahora toda la documentación para futuros reembolsos deberá ser enviada directamente por tu clínica veterinaria a clinic@barkibu.com.\n\nUna vez tu clínica la haya enviado, es importante que vuelvas a abrir una solicitud a través de la app con los mismos documentos, indicando la nota: «Mi clínica ya ha enviado la documentación», para que podamos revisarla.\n\nPor favor, para facilitar la gestión de tus reembolsos, nunca crees una solicitud con documentos que no nos hayan sido enviados previamente por tu clínica al correo indicado."
          },
          {
            "label": "No response from clinic",
            "value": "Hemos cerrado tu solicitud debido a que, con la documentación aportada hasta el momento, no disponemos de suficiente información para emitir una valoración. Hemos intentado contactar con tu clínica varias veces para completar la información, pero no tuvimos éxito.\n\nPara que revisemos tus solicitudes, ponte en contacto con tu clínica para que revisen su correo electrónico.\n\nUna vez nos hayan contestado, podrás volver a abrir la solicitud vía la app."
          },
          {
            "label": "Fraud",
            "value": "Tras revisar la documentación presentada, hemos detectado inconsistencias que nos impiden aprobar su solicitud.\n\nA partir de ahora, toda la documentación para futuros reembolsos deberá ser enviada directamente por su clínica veterinaria a clinic@barkibu.com.\n\nUna vez haya sido enviada por tu clínica, es importante que vuelvas a abrir una solicitud vía la app con los mismos documentos, indicando la nota: \"Mi clínica ya ha enviado la documentación\", para que la podamos revisar.\n\nPor favor, para facilitar la gestión de tus reembolsos, nunca crees una solicitud con documentos que no nos hayan sido previamente enviados por tu clínica al correo previamente indicado."
          }
        ]
      }
    ]
  }
}
